export default {
  title_one: '🥳 {{offer}} applicata',
  title_other: '🥳 {{count}} offerte applicate',
};
